import type { TFunction } from 'i18next';
import { SegmentCategory } from '../../../../../../../../../../modules/audiences/AudienceForm/components/AudienceCriteria/hooks/types';
import type { FormSegment } from '../../../../../../../../../../modules/audiences/AudienceForm/types';

export const getDataTypeName = (segment: FormSegment, t: TFunction, selectedAccountId: string): string => {
  if (
    segment.category === SegmentCategory.PREDEFINED &&
    segment.sub_category?.toLocaleLowerCase() === 'past_browsing_interests'
  ) {
    return t('OXS Data – Browsing Interests');
  }

  if (segment.category === SegmentCategory.PREDEFINED && segment.sub_category?.toLocaleLowerCase() === 'lifestyles') {
    return t('OXS Data – Lifestyles');
  }

  if (
    segment.category === SegmentCategory.PREDEFINED &&
    segment.segment_type?.toLocaleLowerCase() === 'location visits'
  ) {
    return t('OXS Data – Location Visits');
  }

  if (
    segment.category === SegmentCategory.PREDEFINED &&
    segment.segment_type?.toLocaleLowerCase() === 'purchase propensity'
  ) {
    return t('OXS Data – Purchase Propensity');
  }

  if (segment.category === SegmentCategory.PREDEFINED && segment.segment_type?.toLocaleLowerCase() === 'shopping') {
    return t('OXS Data – Shopping');
  }

  if (
    segment.category === SegmentCategory.PREDEFINED &&
    segment.segment_type?.toLowerCase() === 'advanced demographics'
  ) {
    return t('OXS Data – Advanced Demographics');
  }

  if (segment.category === SegmentCategory.PREDEFINED && segment.segment_type?.toLocaleLowerCase() === 'attitudes') {
    return t('OXS Data – Attitudes');
  }

  if (segment.category === SegmentCategory.LOOKALIKE) {
    return t('Lookalike Segments');
  }

  if (segment.sellable && segment.account_id !== selectedAccountId) {
    return t('OXS Data Marketplace');
  }

  if (segment.category === SegmentCategory.DIRECT && segment.account_id === selectedAccountId) {
    return t('My Segments');
  }

  return t('N / A');
};
